import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
import { CommonService } from "../common.service";
var AppToolsComponent = (function () {
    function AppToolsComponent(route, router, commonService, platformLocation) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.assetsRoute = "../../assets";
    }
    AppToolsComponent.prototype.ngOnInit = function () {
    };
    AppToolsComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({ 'backgroundColor': 'rgba(255,255,255,1)' });
    };
    AppToolsComponent.prototype.goLearningMap = function () {
        if (localStorage.getItem('onlyCamp')) {
            this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
        }
        else {
            this.router.navigate(['learning-map']);
        }
    };
    return AppToolsComponent;
}());
export { AppToolsComponent };



// WEBPACK FOOTER //
// ./src/app/app-tools/app-tools.component.ts.pre-build-optimizer.js